import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/core/services/local/loader.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {

  isLoading = this.loaderService.isLoading;
  constructor(
    private loaderService: LoaderService
  ) { }

  ngOnInit(): void {
  }

}
